module.exports = __webpack_public_path__ + "img/waist.66c77535.png";